import { ButtonGroup, tw } from "@sveabank/cc-common";

type Props = {
	children: React.ReactNode;
	paddingTop?: keyof typeof paddingVariant;
};

const paddingVariant = {
	none: "pt-0",
	base: "pt-20",
	sign: "pt-12",
};

const PageNavigationFooter = ({ children, paddingTop = "base" }: Props) => (
	<footer className={tw(paddingVariant[paddingTop])}>
		<ButtonGroup row align="start">
			{children}
		</ButtonGroup>
	</footer>
);

export default PageNavigationFooter;
